(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/assets/javascripts/react/corp-info.js') >= 0) return;  svs.modules.push('/modules/login-iam/assets/javascripts/react/corp-info.js');

'use strict';

var _svs;
const Brand = svs.ui.ReactBrand;
const isMomang = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 || (_svs = _svs.site) === null || _svs === void 0 ? void 0 : _svs.toLowerCase()) === 'momang';
const CorpInfo = () => React.createElement("div", {
  className: "".concat(isMomang ? 'fc-white ' : '', "login-iam-corp-info")
}, React.createElement(Brand, {
  brand: isMomang ? 'svenskaspel-twolines-neg' : 'svenskaspel-twolines',
  emblem: true
}), React.createElement("p", {
  className: "margin-top-1"
}, "Spel fr\xE5n Svenska Spel Sport & Casino AB"), React.createElement("p", null, "Spel f\xF6r dig \xF6ver 18 \xE5r | St\xF6dlinjen:", React.createElement("a", {
  "aria-label": "Ring st\xF6dlinjen",
  className: "u-text-decoration-underline ".concat(isMomang ? 'fc-white ' : 'fc-sport-75'),
  href: "tel:020819100"
}, " 020-81 91 00")));
svs.login_iam.CorpInfo = CorpInfo;

 })(window);